import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const placement = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    startDate: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('When the placement begins.'),

    endDate: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('When the placement ends.'),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    positionId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to Position'),

    candidate: belongsTo('Candidate'),

    position: references('Position', 'positionId'),
  })
  .describe('Assigns a candidate to a specific position for an event.')
  .as('Placement');

export { placement as placementSchema };
